import SysAppLoggerList from "../component/SysAppLoggerList";
import React from "react";

const SysAppLoggerListContainer = ({ pageId }) => (<SysAppLoggerList pageId={ pageId } />)

export default SysAppLoggerListContainer;